import { render, staticRenderFns } from "./ExternalVideo.vue?vue&type=template&id=1bb77daf&scoped=true&"
import script from "./ExternalVideo.vue?vue&type=script&lang=ts&"
export * from "./ExternalVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalVideo.vue?vue&type=style&index=0&id=1bb77daf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb77daf",
  null
  
)

export default component.exports